import React, { createContext, useState } from "react";
export const SetUserContext = createContext();

export const SetUserContextProvider = ({ children }) => {
    // Address
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [ibge, setIbge] = useState("");
    const [cep, setCep] = useState("");
    const [neighborhood, setNeighborhood] = useState("");
    const [region, setRegion] = useState("");
    const [street, setStreet] = useState("");
    const [numberAddress, setNumberAddress] = useState("");
    const [uf, setUf] = useState("");
    const [complement, setComplement] = useState("");

    // Company
    const [logo, setLogo] = useState("");
    const [corporateName, setCorporateName] = useState("");
    const [landline, setLandline] = useState("");
    const [phone, setPhone] = useState("");
    const [cnpj, setCnpj] = useState("");
    const [webSite, setWebSite] = useState("");
    const [emailCompany, setEmailCompany] = useState("");

    // User
    const [name, setName] = useState("");
    const [cpf, setCpf] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [telephone, setTelephone] = useState("");


    return (
        <SetUserContext.Provider value={
            {
                // Address
                city, setCity,
                state, setState,
                ibge, setIbge,
                cep, setCep,
                neighborhood, setNeighborhood,
                region, setRegion,
                street, setStreet,
                numberAddress, setNumberAddress,
                uf, setUf, complement, setComplement,
                // Company
                logo, setLogo,
                corporateName, setCorporateName,
                landline, setLandline,
                phone, setPhone,
                cnpj, setCnpj, emailCompany, setEmailCompany,
                webSite, setWebSite,
                // User
                name, setName,
                cpf, setCpf,
                email, setEmail,
                password, setPassword,
                telephone, setTelephone
            }
        } >
            {children}
        </SetUserContext.Provider>
    )
}




